import styled from "styled-components";

import Loader from "components/Layout/Loader";
import SearchDefault from "components/Input/Search";

import { COLORS } from "constants/colorScheme";

export const PageControl = styled.div`
  :not(:last-child) {
    margin-right: 40px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  margin-bottom: 30px;
`;

export const SearchControls = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SearchControlWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const Search = styled(SearchDefault)`
  width: 300px;
`;

export const WorkoutCardWrapper = styled.div`
  :not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const ScrollLoader = styled(Loader)`
  height: 100px;
`;

export const OverflowLoader = styled(Loader)`
  position: absolute;
  z-index: 10;

  background-color: ${COLORS.WHITE_40};
`;
